import builder from './builder';
import SearchForm from 'app/components/search-results/SearchForm';
import ResultList from 'app/components/search-results/SearchResults/Mobile';

/**
 * Mobile search result page that just composes all SRP mobile
 * components together in one Layout.
 * @return {Component}
 */
const MobileSearchResultsPage = builder({
  SearchForm,
  ResultList,
});

export default MobileSearchResultsPage;
